module.exports = __webpack_public_path__ + "media/logos/commercial_edge-6e7ec0c7.png";